module.exports = __webpack_public_path__ + "img/register_confirmation.f864a944.png";